import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMemo } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import useCampaignPortalSync from '@hooks/useCampaignPortalSync'

const CampaignPortalSyncsActions = (props: { campaignPortalSync: { id: number } }) => {
  const { campaignPortalSync } = props

  const {
    callbacks: { manageCampaignPortalSyncDetails },
  } = useCampaignPortalSync(campaignPortalSync)

  return (
    <Box justifyContent="center">
      <Link greyLink onClick={() => manageCampaignPortalSyncDetails()}>
        <FontAwesomeIcon icon={faMemo} />
      </Link>
    </Box>
  )
}

export default CampaignPortalSyncsActions
